export default __webpack_public_path__ + "static/media/contactBg.f3e25092.jpg";